import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function GuideSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="relative overflow-hidden rounded-2xl bg-white border border-background-200 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-40 h-40 bg-primary-50 rounded-full -translate-y-1/2 translate-x-1/4 opacity-50"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-accent-50 rounded-full translate-y-1/2 -translate-x-1/4 opacity-50"></div>

          <div className="relative z-10">
            <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-book-open-line w-7 h-7 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">
              {t('guide_title')}
            </h3>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-6">
              {t('guide_description')}
            </p>
            <Link
              to="/article/yoybuy-spreadsheet-guide"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-300 text-base cursor-pointer"
            >
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
              {t('btn_read_guide')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}